export const dividendsDistributionModalInitValue = {
  data: {
    date: '',
    comments: '',
    file: undefined,
    scriptureView: true,
    lastOperationDate: '',
    totalPartners: 0,
    totalAmount: 0,
    hasRetention: false,
    retentionPercentage: 0,
    dividends: [],
    customRetentions: [],
    page: 1,
    rowsPerPage: 10,
    isLoading: false,
    isDividendsLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    handleChangeTotalAmount(): void {},
    handleChangeHasRetention(): void {},
    handleChangeRetentionPercentage(): void {},
    handleChangeCustomRetention(): void {},
    handleChangePage(): void {},
    handleChangeRowsPerPage(): void {},
    handleSaveDividends(): void {},
  },
};
